module.exports = __webpack_public_path__ + "img/calendar.cb27959f.png";